import {
  horyu,
  rejectKariHoryu,
  acceptKariHoryu,
  kariHoryu,
  kariShonin,
  shonin,
  rejectKariShonin,
  acceptKariShonin,
} from "@/api/shinsei.api";
import { ComfirmMsg, ConfirmText, InfoMsg } from "@/constants/message.constant";
import { shinseiModel, shoninModel } from "@/interfaces/shinsei.interface";
import { ElMessage, ElMessageBox } from "element-plus";
import { Ref } from "vue";
import { Buttons } from "./config";

export function handleShoninshaButtons(
  shoninFormRef: Ref<any>,
  panels: {
    shinseiInfo: any;
    shinseishaInfo: any;
    shoninshaInfo: any;
    shinseiForm: shinseiModel;
    shoninForm: shoninModel;
  },
  handleReload: (id?: string) => void,
  loadings: Buttons
) {
  const generateShoninData = () => {
    const data: shoninModel = Object.assign(
      {
        id: panels.shinseiInfo.id,
        torokuAccountId: panels.shinseiForm.torokuAccountId,
        kigyonaiShinchokuCdShinsei: panels.shinseiInfo.shinchokuCdShinsei,
        kigyonaiShinchokuCdShonin: panels.shinseiInfo.shinchokuCdShonin,
        statusCd: panels.shinseiInfo.statusCd,
      },
      panels.shoninForm
    );
    return data;
  };

  //承認ボタン押下
  const handleShonin = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.shoninBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_SHONIN,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await shonin(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_SHONIN_COMPLETED,
            });
            loadings.shoninBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.shoninBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮承認ボタン押下
  const handleKariShonin = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShoninBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_KARI_SHONIN,
          type: "success",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await kariShonin(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_KARI_SHONIN_COMPLETED,
            });
            loadings.kariShoninBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariShoninBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //保留ボタン押下
  const handleHoryu = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.shoninBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_HORYU,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await horyu(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_HORYU_COMPLETED,
            });
            loadings.shoninBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.shoninBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮保留ボタン押下
  const handleKariHoryu = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariHoryuBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_KARI_HORYU,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await kariHoryu(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_KARI_HORYU_COMPLETED,
            });
            loadings.kariHoryuBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariHoryuBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮承認→承認ボタン押下
  const handleShoninOk = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShoninOkBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_SHONIN,
          type: "success",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await acceptKariShonin(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_SHONIN_COMPLETED,
            });
            loadings.kariShoninOkBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariShoninOkBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮保留→保留ボタン押下
  const handleHoryuOk = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariHoryuOkBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_HORYU,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await acceptKariHoryu(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_HORYU_COMPLETED,
            });
            loadings.kariHoryuOkBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariHoryuOkBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮承認→取消ボタン押下
  const handleShoninNg = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShoninNgBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_TORIKESI,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await rejectKariShonin(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_TORIKESI_COMPLETED,
            });
            loadings.kariShoninNgBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariShoninNgBtn = false;
          });
      } else {
        return false;
      }
    });
  };

  //仮保留→取消ボタン押下
  const handleHoryuNg = () => {
    shoninFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariHoryuNgBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_TORIKESI,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            const data = generateShoninData();
            await rejectKariHoryu(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_TORIKESI_COMPLETED,
            });
            loadings.kariHoryuNgBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariHoryuNgBtn = false;
          });
      } else {
        return false;
      }
    });
  };
  return {
    handleShonin,
    handleKariShonin,
    handleHoryu,
    handleKariHoryu,
    handleShoninOk,
    handleHoryuOk,
    handleShoninNg,
    handleHoryuNg,
  };
}
